if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();

          this.setupConstants();
          this.initSelectors();

          let countdownData = this.dataset.countdownTimer;
          let timeNow = new Date().getTime();
          let hours = this.dataset.hours;

        
          if (hours) {
            countdownData = new Date().getTime() + hours * this.MILLISECONDS.HOUR;

            let countDownStored = localStorage.getItem('countDownStored');
            console.log(countDownStored,timeNow);
            if(countDownStored !== null){
              countDownStored = parseInt(countDownStored);
              if(countDownStored   < timeNow  ){
                localStorage.setItem('countDownStored', countdownData);
              }else{
                countdownData = countDownStored;
              }
            }else{
              localStorage.setItem('countDownStored', countdownData);
            }
          }
          

          
          if (countdownData) {
            this.initializeCountdown(countdownData);
          }
      }

      setupConstants() {
        this.MILLISECONDS = {
          DAY: 24 * 60 * 60 * 1000,
          HOUR: 60 * 60 * 1000,
          MINUTE: 60 * 1000,
          SECOND: 1000,
        };
        this.intervalDuration = 1000;
      }

      initSelectors() {
        this.selectorMapping = {
          day: '[data-timer-day]',
          hour: '[data-timer-hour]',
          minute: '[data-timer-minute]',
          second: '[data-timer-second]',
          dayLabel: '[data-timer-day-label]',
          hourLabel: '[data-timer-hour-label]',
          minuteLabel: '[data-timer-minute-label]',
          secondLabel: '[data-timer-second-label]'
        };
        this.units = ['day', 'hour', 'minute', 'second'];
      }

      initializeCountdown(countdownData) {
        this.startTime = Date.now();
        this.targetTime = new Date(countdownData).getTime();
        this.loop = false;
        this.onComplete = () => {};
        this.shouldAddLeadingZero = true;

        if (this.targetTime > this.startTime) {
          this.fetchDomElements();
          this.beginCountdown();
        }
      }

      fetchDomElements() {
        this.elements = {};
        this.labels = {};
        this.units.forEach((unit) => {
          this.elements[unit] = this.querySelector(this.selectorMapping[unit]);
          this.labels[unit] = this.querySelector(this.selectorMapping[unit + 'Label']);
        });
      }

      beginCountdown() {
        this.intervalId = setInterval(() => {
          const remainingTime = this.targetTime - Date.now();
          if (remainingTime <= 0) {
            this.terminateCountdown();
          } else {
            this.updateDisplay(remainingTime);
          }
        }, this.intervalDuration);
        this.classList.remove('hidden');
      }

      updateDisplay(remainingTime) {
        const timeComponents = this.computeTimeComponents(remainingTime);
        this.units.forEach((unit) => {
          if (this.elements[unit]) {
            if(unit === 'day' && timeComponents[unit] === 0){
                this.elements[unit].closest('.countdown-timer__block').style.display = 'none';
              }else{
                this.elements[unit].textContent = this.formatTimeComponent(timeComponents[unit]);
              }
            }
        });
      }

      computeTimeComponents(ms) {
        return {
          day: Math.floor(ms / this.MILLISECONDS.DAY),
          hour: Math.floor((ms % this.MILLISECONDS.DAY) / this.MILLISECONDS.HOUR),
          minute: Math.floor((ms % this.MILLISECONDS.HOUR) / this.MILLISECONDS.MINUTE),
          second: Math.floor((ms % this.MILLISECONDS.MINUTE) / this.MILLISECONDS.SECOND),
        };
      }

      formatTimeComponent(value) {
        return this.shouldAddLeadingZero && value < 10 ? `0${value}` : value.toString();
      }

      terminateCountdown() {
        clearInterval(this.intervalId);
        if (this.loop) {
          this.beginCountdown();
        } else {
          this.onComplete();
          this.classList.add('hidden');
        }
      }

      resetCountdown() {
        clearInterval(this.intervalId);
        this.units.forEach((unit) => {
          if (this.elements[unit]) {
            this.elements[unit].textContent = '00';
          }
        });
      }
    }
  );
}
